import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "reload-config-dialog"
};
var _hoisted_2 = {
  class: "d-flex fl-col fl-j-c fl-a-c progress-container"
};
var _hoisted_3 = {
  class: "progress-bar"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_progress = _resolveComponent("el-progress");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("posconfiguration.downloading")), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_progress, {
        percentage: _ctx.progressValue,
        class: "progress"
      }, null, 8, ["percentage"])])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}